import React from "react"
import { Popover, Tooltip, Form, Button } from "antd"
// @ts-ignore
import { Checkbox, Switch } from "components-design-system"
import { uniq } from "lodash"

// @ts-ignore
import useGlobalFilterStore from "context/stores/useGlobalFilterStore"
// @ts-ignore
import { useGetGlobalFilter, usePostGlobalFilter } from "api/hooks/global"

import "./GlobalFilter.scss"

interface FilterMap {
  studies: string[]
  requests: string[]
}

export default function GlobalFilter() {
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = React.useState<boolean>(false)
  const { data: globalFilter } = useGetGlobalFilter()
  const postGlobalFilter = usePostGlobalFilter()
  const { setMyFilteredRecordsMap, setIsFilterOn, isFilterOn } = useGlobalFilterStore()

  React.useEffect(() => {
    try {
      const updateFilteredMap = ({ studies, requests, map }: { studies: string[]; requests: []; map: FilterMap }) => {
        if (studies) {
          studies.forEach((studyId: string) => {
            map.studies.push(studyId)
          })
        }

        if (requests) {
          requests.forEach((requestId: any) => {
            map.requests.push(requestId)
          })
        }

        return map
      }

      if (globalFilter) {
        // @ts-ignore
        let map: FilterMap = {
          studies: [],
          requests: [],
        }

        if (globalFilter?.my_filter?.enable) {
          map = updateFilteredMap({
            studies: globalFilter.my_filter.filter_study_ids,
            requests: globalFilter.my_filter.filter_request_ids,
            map,
          })
        }

        if (globalFilter?.fav_filter?.enable) {
          map = updateFilteredMap({
            studies: globalFilter.fav_filter.filter_study_ids,
            requests: globalFilter.fav_filter.filter_request_ids,
            map,
          })
        }

        map.studies = uniq(map.studies)
        map.requests = uniq(map.requests)
        setMyFilteredRecordsMap({
          studies: new Set(map.studies),
          requests: new Set(map.requests),
        })
      }
    } catch (error) {
      console.log({ error })
    }
  }, [globalFilter])

  React.useEffect(() => {
    const hasFilter =
      // globalFilter?.my_filter?.enable || globalFilter?.fav_filter?.enable || globalFilter?.exclude_archived
      globalFilter?.my_filter?.enable || globalFilter?.fav_filter?.enable
    setIsFilterOn(hasFilter)
  }, [JSON.stringify(globalFilter)])

  // @ts-ignore
  const onSaveFilter = (values) => {
    setIsLoading(true)
    if (postGlobalFilter) {
      setIsLoading(true)
      postGlobalFilter(
        {
          body: {
            my_filter: { enable: values.my_filter },
            fav_filter: { enable: values.fav_filter },
            exclude_archived: !values.exclude_archived,
          },
        },
        {
          onSuccess: () => window.location.reload(),
          onSettled: () => {
            setIsLoading(false)
          },
        }
      )
    }
  }

  // @ts-ignore
  const onFilterValueChange = (params) => {
    if (params?.my_filter) {
      form.setFieldsValue({ all_records: false })
    }

    if (params?.fav_filter) {
      form.setFieldsValue({ all_records: false })
    }

    if (params?.all_records) {
      form.setFieldsValue({ my_filter: false, fav_filter: false })
    }
  }

  const popoverContent = (
    <Form
      form={form}
      className="filter-option-container"
      // @ts-ignore: Suppress TypeScript error for onFinish type
      onFinish={onSaveFilter}
      initialValues={{
        // @ts-ignore: Suppress TypeScript error for potentially undefined globalFilter
        my_filter: globalFilter?.my_filter?.enable || false,
        fav_filter: globalFilter?.fav_filter?.enable || false,
        all_records: !globalFilter?.my_filter?.enable && !globalFilter?.fav_filter?.enable,
        exclude_archived: !globalFilter?.exclude_archived || false,
      }}
      onValuesChange={onFilterValueChange}
    >
      <Form.Item
        name="my_filter"
        valuePropName="checked"
      >
        <Checkbox
          label="My Records"
          tooltip="Shows records where you are directly involved"
        />
      </Form.Item>
      <Form.Item
        name="fav_filter"
        valuePropName="checked"
      >
        <Checkbox
          label="Favorite Records"
          tooltip="Shows records you’ve marked as favorites"
        />
      </Form.Item>
      <Form.Item
        name="all_records"
        valuePropName="checked"
      >
        <Checkbox
          label="All Records"
          tooltip="Shows all available records"
        />
      </Form.Item>
      <Form.Item
        name="exclude_archived"
        valuePropName="checked"
      >
        <Switch label="Include Archived Studies" />
      </Form.Item>
      <Form.Item>
        <Button
          loading={isLoading}
          style={{ marginTop: 10, width: "100%" }}
          htmlType="submit"
        >
          Save Filter
        </Button>
      </Form.Item>
    </Form>
  )

  return (
    <div className={`global-filter-container ${isFilterOn ? "has-badge" : ""}`}>
      <Popover
        trigger="click"
        title="Global Filter"
        placement="bottomRight"
        content={popoverContent}
      >
        <i
          className="fa-light fa-sliders global-filter-icon"
          role="button"
          aria-haspopup="true"
        />
      </Popover>
    </div>
  )
}
